import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import preview from './openSubmissionsTilePreview.png';
import previewBack from './openSubmissionsTilePreview2.png';

export const openSubmissionsTileDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                The Open Submissions Capsule is a transparency tool as it
                displays how the algo is working by listing where portions of
                your order are open in the market.
            </div>
            <div>
                It provides an overview of your order, what has executed and how
                the algo is intending to execute.
            </div>
        </>
    ),
    previews: [
        { src: preview, altText: 'open-submissions-preview', title: 'Front' },
        {
            src: previewBack,
            altText: 'open-submissions-back-preview',
            title: 'Back',
        },
    ],
};
